export default __webpack_public_path__ + "static/media/dollar.6efafc2c.svg";